import { t } from "../i18n/runtime";
import { useCallback, useEffect, useRef, useState } from "react";

/**
 * Start over.
 *
 * A reload rather than an in-place teardown: the app opens its session on
 * mount, and between a Phaser instance, a socket and a module-level boot latch
 * there is no partial reset that is obviously correct. Throwing the page away
 * cannot leave half a game behind.
 *
 * It asks twice. One click ends a round in progress — and on a paid session,
 * starts a new one that spends — so a control sitting a thumb's width from the
 * map wants a second beat before it does that. It disarms itself, because a
 * button left armed is a button that catches the next unrelated click.
 */
const ARMED_MS = 3_000;

export function RestartButton() {
  const [armed, setArmed] = useState(false);
  const timer = useRef(0);

  useEffect(() => () => window.clearTimeout(timer.current), []);

  const click = useCallback(() => {
    if (armed) {
      window.location.reload();
      return;
    }
    setArmed(true);
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setArmed(false), ARMED_MS);
  }, [armed]);

  return (
    <button
      type="button"
      className={armed ? "hud-restart hud-restart--armed" : "hud-restart"}
      onClick={click}
      title={
        armed
          ? t("RestartButton.press_again_to_discard_this_round_and")
          : t("RestartButton.open_a_new_round_the_current_round")
      }
    >
      {armed ? t("RestartButton.press_again") : t("RestartButton.restart")}
    </button>
  );
}
